/* eslint-disable @typescript-eslint/naming-convention */
import { Observable, Subject } from 'rxjs';

export interface FilterField {
    displayKey: string;
    displayName: string;
    fieldKey: string;
    fieldType: string;
    multiSelect?: boolean;
    fieldOptions?: Array<any>;
    operators: Array<string>;
    dataURL?: string;
}
export interface FilterOptionValue {
    key: string;
    operator: string;
    value: any;
    displayKeyValue?: Array<string>;
    operatorDisplayKey?: string;
    field_type?: string;
    showForm?: boolean;
    valueSubject$?: Subject<string | null>;
    datetime?: any;
    time?: any;
    date?: any;
    datetime2?: any;
    time2?: any;
    date2?: any;
    value2?: any;
    listPreData?: Array<any>;
    module?: string;
    type?: string;
    checked?: Array<any>;
    rangeKey?: string;
    filterKey?:any;
}

export interface AppliedFilterValue {
    action?: string;
    module: string;
    saveFilter: boolean;
    filterRules?: Array<FilterOptionValue>;
}

export interface FilterFieldOption {
    displayKey: string;
    displayName: string;
    fieldDataKey?: string;
    filterOptionKey?: string;
    fieldLabelKey?: string;
    fieldType: string;
    type: string;
    multiSelect?: boolean;
    fieldOptions?: Array<any>;
    operators?: Array<{
                        displayKey: string;
                        displayValue: string;
                    }>;
    data?: {
        url: string;
        lazyLoad: boolean;
        searchParam: string;
        dataKey: string;
        bindLabel: string;
        listValue$?: Observable<any>;
    };
}

export interface GenerateFilterOptions{
    title?: string;
    footerClass?: string;
    headerClass?: string;
    showSaveFilter?: boolean;
    extraClass?: string;
    data?: any;
    isManageFilter?: boolean;
}

export const OperatorEn = {
    EQUAL_TO: 'quickFilter.filter.operators.equal_to',
    NOT_EQUAL_TO: 'quickFilter.filter.operators.not_equal_to',
    CONTAINS: 'quickFilter.filter.operators.contains',
    NOT_CONTAINS: 'quickFilter.filter.operators.not_contains',
    IS_EMPTY: 'quickFilter.filter.operators.is_empty',
    IS_NOT_EMPTY: 'quickFilter.filter.operators.is_not_empty',
    GREATER_THAN: 'quickFilter.filter.operators.greater_than',
    LESS_THAN_EQUAL_TO: 'quickFilter.filter.operators.less_than_equal_to',
    GREATER_THAN_EQUAL_TO: 'quickFilter.filter.operators.greater_than_equal_to',
    LESS_THAN: 'quickFilter.filter.operators.less_than',
    BETWEEN: 'quickFilter.filter.operators.between'
};

export interface AdditionalFilter{
    key?: string;
    filter?: any;
}
